module.exports = {
    "teacher_room": {
        "title": "L'assistant pédagogique des super-profs"
    },
    "animator_room": {
        "title": "L'assistant pédagogique des super-anims"
    },
    "versionquatrecinq":{
        "cestici":"********************************"
    },
    "rooms": {
        "integrate_lili": {
            "teacher": {
                "title": "Comment intégrer Lili dans le temps de classe",
                "chapo": "Découvrez les diverses pratiques de Lili pour répondre au programme de l’Education nationale et aux besoins éducatifs particuliers.",
                "body": "Les témoignages, les séquences pédagogiques, les programmations sur 5 semaines."
            },
            "family": {
                "title": "Comment utiliser Lili à la maison",
                "chapo": "Des conseils d’experts en pédagogie et neurosciences pour aider son enfant à gérer ses émotions, trouver le sommeil, se concentrer, et grandir en confiance.",
                "body": "7 super-parcours, des activités et rituels audio, un programme bien-être des parents"
            },
            "animator": {
                "title": "Comment utiliser Lili en périscolaire",
                "chapo": "Découvrez les diverses pratiques de Lili pour répondre aux besoins des animateurs du périscolaire ou en accueil de loisirs, et des référents familles en centre social.",
                "body": "Les témoignages, les projets d’animation, les plannings pour le périscolaire, le PRE/CLAS et les mercredis / vacances."
            },
            "button": {
                "title": "Découvrir"
            }
        },
        "actus": {
            "webinar": {
                "title": "Le webinar :\nLes mercredis",
                "body": "Participez au webinar découverte de Lili, dont un spécial maternelles",
                "link": "https://app.livestorm.co/lilicool"
            },
            "comity": {
                "title": "Présentation du comité scientifique de Lili",
                "body": "Damien Tessier, Violaine Blanc, Grégoire Borst, Edwige Chirouter, Jean-Charles Pettier",
                "link": "https://www.lili.cool/fr/comite_scientifique/"
            },
            "read_advice": {
                "title": "10 conseils de Charivari pour lire à voix haute",
                "body": "Une série vidéo conçue par Lili avec les Petits champions de la lecture",
                "link": "https://www.lili.cool/fr/conseils-lecture-voix-haute-charivari/"
            },
            "witness": {
                "title": "Témoignages de super-anims",
                "body": "\"Simple et clé-en-main pour l'animation périscolaire et l’extrascolaire\"",
                "link": "https://www.lili.cool/fr/activites_animation_periscolaire/"
            },
            "animation_project": {
                "title": "7 projets d'animation clé-en-main",
                "body": "Avec les plannings “périscolaire” et\n“mercredi / vacances” et les fiches d’activités.",
                "link": "https://www.lili.cool/fr/projet-animation/"
            },
            "sleep_advice": {
                "title": "Aidez votre enfant à trouver le sommeil",
                "body": "Avec les neurosciences et les relaxations pour s’endormir de Lili",
                "link": "https://www.lili.cool/fr/sommeil-enfant-adolescent/"
            },
            "models": {
                "title": "Des rôles modèles pour agir sur les préjugés",
                "body": "Et si pour grandir, les petites (et les petits) s’inspiraient des plus grandes",
                "link": "https://www.lili.cool/fr/deconstruire-prejuges-pour-meilleure-mixite/"
            },
            "manifesto": {
                "title": "Manifesto Lili :\nNos convictions",
                "body": "Pour la confiance et la réussite de chaque enfant",
                "link": "https://www.lili.cool/fr/manifesto-lili/"
            }
        },
        "auto_trainings": {
            "title": {
                "animator": "Les modules d'auto-formation",
                "teacher": "Les modules d'auto-formation",
                "family": "Bien-être et compétences psychosociales des parents"
            },
            "cps": {
                "title": "Sensibilisation aux compétences psychosociales",
                "body": "4h de podcasts inédits pour tout savoir sur les CPS, conçus par la psychologue Violaine Blanc et le chercheur Damien Tessier : qu'en dit la recherche ? Comment les développer ? Quelle posture adopter ?"
            },
            "philo": {
                "title": "Formation aux ateliers philo",
                "body": "Des programmes d’accompagnement d’une qualité unique, conçus par Edwige Chirouter et Jean-Charles Pettier, professeurs universitaires, chercheurs, formateurs et auteurs de référence."
            },
            "well_being": {
                "teacher": {
                    "title": "Bien-être des super-profs",
                    "body": "Respirer, se détendre, réduire son stress, croire en soi… Parce que votre bien-être est aussi essentiel que celui de vos élèves, Lili a conçu un programme spécialement pour vous !"
                },
                "family": {
                    "title": "Bien-être des super-parents",
                    "body": "Respirer, se détendre, réduire son stress, croire en soi… Parce que votre bien-être est aussi essentiel que celui de votre enfant, Lili a conçu un programme spécialement pour vous !"
                },
                "animator": {
                    "title": "Bien-être des super-anims",
                    "body": "Respirer, se détendre, réduire son stress, croire en soi… Parce que votre bien-être est aussi essentiel que celui des enfants, Lili a conçu un programme spécialement pour vous !"
                }
            }
        },
        "trainings": {
            "title": "Formation en présentiel\navec intervention d'experts Lili",
            "body": "Dans le cadre du déploiement de ses programmes, Lili intervient en présentiel sur site (établissement scolaire, accueil de loisirs, centre social, EAFC…) pour former tous les professionnels de l’éducation et de l’animation",
            "button": "En savoir plus",
            "link": "https://www.lili.cool/fr/formation-sur-les-competences-psychosociales/"
        }
    },
    "menu": {
        "activities": {
            "teacher": "Les activités",
            "family": "Les activités",
            "animator": "Les activités",
            "extra": {
                "title": {
                    "teacher": "Les activités à la une",
                    "family": "Les activités à la une",
                    "animator": "Les activités à la une"
                }
            }
        },
        "sequences": {
            "teacher": "Les séquences pédagogiques",
            "family": "Les super-parcours",
            "animator": "Les projets d'animation"
        }
    },
    "about": {
        "title": "À propos",
        "legalMentions": "Mentions légales",
        "personalData": "Données personnelles",
        "contact": "Nous contacter",
        "description": [
            "Conçu avec le soutien de la Recherche et de l’Education nationale, Lili est un programme de développement des compétences psychosociales et langagières en milieu scolaire et périscolaire, de la maternelle au collège. Lili associe des ressources au sein d'une application audio à une offre de formation pour accompagner la montée en compétences des enseignants, des animateurs et des familles. Sa pédagogie centrée sur l’oral développe l’estime de soi et la persévérance via des récits de rôles modèles en parité et en diversité, la régulation des émotions via des relaxations guidées, l’aisance à l’oral et la coopération via l’improvisation, et l’esprit critique via des podcasts philo pour enfants. Labellisé Edu-Up par l'Éducation nationale, finaliste du Global Edtech Startup Award 2023, Prix Coup de cœur des collectivités de Ludovia 2024, et finaliste La France s’engage 2025, Lili est la 2è ressource numérique souscrite par les enseignants des territoires numériques éducatifs, utilisée dans plus de 6000 classes et accueils de loisirs, et prolongée par un usage à la maison."
        ]
    },
    "accessibility": {
        "openTheMenu": "Ouvrir le menu",
        "openUserProfile": "Ouvrir le profil utilisateur"
    },
    "activities": {
        "grow": {
            "media": {
                "intro": "Pour aller plus loin avec vos élèves, découvrez des histoires sur ce thème"
            }
        },
        "workshop": {
            "media": {
                "intro": "Liste des supports pédagogiques"
            }
        },
        "media": {
            "intro": "Liste des supports"
        },
        "bio": {
            "media": {
                "intro": "Voici des activités à faire en lien avec ce rôle modèle."
            }
        },
        "tuto": {
            "goldenRules": "Les règles d'or",
            "rulesActionButtonTitle": "Suivant",
            "actionButtonLast": "Précédent",
            "actionButtonNext": "Suivant",
            "step": "Étape",
            "mediaChecking": "Vérification des médias....",
            "mediaDownloading": "Téléchargement des médias...",
            "cancel": " Annuler"
        },
        "summary": {
            "title": "Résumé du podcast"
        },
        "favorites": {
            "addAsFavTitle": "Super !",
            "addAsFavBody": "Vous avez beaucoup aimé cette activité,\nretrouvez-la dans votre profil.",
            "removeAsFavTitle": "C'est noté !",
            "removeAsFavBody": "Nous avons enlevé cette activité de vos favoris."
        },
        "downloads": {
            "addTitle": "Super !",
            "addBody": "Cette activité est maintenant disponible hors-ligne.\nRetrouvez-la dans votre profil.",
            "removeTitle": "C'est noté !",
            "removeBody": "Cette activité n'est maintenant plus disponible hors-ligne."
        }
    },
    "app": {
        "title": "%{app_name} - %{version} - %{build}"
    },
    "appMenu": {
        "parents": {
            "activitiesTitle": "Choisis tes activités",
            "button": {
                "title": "Le coin\ndes super-parents",
                "body": "Conseils d'experts et programme\nbien-être pour les parents."
            }
        },
        "teachers": {
            "activitiesTitle": "Choisir les activités pédagogiques",
            "button": {
                "title": "La salle\ndes super-profs",
                "body": "Accompagnement, formation et bien-être pour votre développement professionnel !"
            }
        },
        "animators": {
            "activitiesTitle": "Choisir les activités pédagogiques",
            "button": {
                "title": "Le coin\ndes super-anims",
                "body": "Accompagnement, formation et bien-être pour votre développement professionnel !"
            }
        },
        "extra": {
            "teachers": {
                "title": "Imprimer le matériel pour la classe",
                "first": {
                    "title": "Le parcours",
                    "body": "Les petits pas"
                },
                "second": {
                    "title": "Le poster",
                    "body": "des super-pouvoirs"
                }
            },
            "animators": {
                "title": "Imprimer le matériel pour le centre",
                "first": {
                    "title": "Le parcours",
                    "body": "Les petits pas"
                },
                "second": {
                    "title": "Le poster",
                    "body": "des super-pouvoirs"
                }
            },
            "family": {
                "title": "Installe ta routine de super-héros",
                "first": {
                    "title": "Les petits pas",
                    "body": "chaque jour"
                },
                "second": {
                    "title": "Bien m'endormir",
                    "body": "chaque soir"
                }
            }
        },
        "profileTitle": "Mon\nprofil",
        "switchMenu": {
            "coachManual": "Pour les parents",
            "about": "À propos",
            "profile": "Mon compte"
        }
    },
    "authentication": {
        "landing": {
            "signin": "Je me connecte",
            "signup": "Je m'inscris"
        },
        "animator": {
            "introduction": {
                "title": "Faire grandir la confiance sur le temps périscolaire, c’est facile et ludique avec Lili !",
                "body": "Lili offre aux super-anims des temps périscolaires et extrascolaires, de courts ateliers collectifs sur les compétences psychosociales pour développer l’intelligence émotionnelle, l’aisance à l’oral et le vivre ensemble des 3-15 ans. Peu d’équipement et de formation étant nécessaires, chaque éducateur peut les mettre en place très facilement à l’école ou en accueil de loisirs.",
                "or": "ou",
                "buttons": {
                    "main": "Contactez-nous pour un devis",
                    "second": "Créez un compte"
                }
            }
        },
        "userTypeChoice": {
            "liliAtHome": {
                "pre_intro": "Libérez les",
                "post_intro": "de vos enfants",
                "button": "Je suis\nsuper-parent"
            },
            "liliAtSchool": {
                "pre_intro": "Améliorez le",
                "post_intro": "en classe",
                "button": "Je suis\nsuper-prof"
            }
        },
        "forgotPassword": {
            "title": "Vous avez perdu votre mot de passe ?",
            "body": "Saisissez l'e-mail avec lequel vous vous êtes inscrit(e) pour choisir un nouveau mot de passe",
            "buttons": {
                "send": "Envoyer",
                "cancel": "Annuler"
            },
            "form": {
                "emailPlaceholder": "Votre e-mail"
            }
        },
        "signIn": {
            "title": "Nous sommes contents de vous revoir !",
            "form": {
                "emailPlaceholder": "Votre e-mail",
                "passwordPlaceholder": "Votre mot de passe",
                "passwordLegend": "6 caractères minimum"
            },
            "buttons": {
                "signIn": "C'est parti !",
                "signUp": "Pas encore de compte ?",
                "forgotPassword": "Mot de passe oublié ?"
            }
        },
        "signUp": {
            "title": "Bienvenue chez LILI !",
            "errors": {
                "empty_firstname": "Votre prénom ne peut pas être vide",
                "empty_lastname": "Votre nom ne peut pas être vide",
                "empty_email": "Votre e-mail ne peut pas être vide",
                "empty_password": "Votre mot de passe ne peut pas être vide",
                "wrong_email": "La saisie de votre e-mail est incorrect",
                "wrong_password": "Votre mot de passe doit contenir 6 caractères minimum",
                "empty_organisation_name": "Le nom de votre organisation ne peut pas être vide",
                "empty_organisation_address": "L'adresse de votre organisation ne peut pas être vide",
                "empty_organisation_zip": "Le code postal de votre organisation ne peut pas être vide",
                "empty_organisation_city": "La ville de votre organisation ne peut pas être vide",
                "empty_organisation_country": "Le pays de votre organisation ne peut pas être vide"
            },
            "form": {
                "welcome": "Bienvenue\naux super-profs",
                "toStart": {
                    "title": "Pour bien démarrer, rendez-vous dans les ressources de l'enseignant",
                    "body": {
                        "tuto": "• Visionnez le tutoriel",
                        "advice": "• Lisez nos conseils",
                        "webinar": "• Participez au webinar"
                    }
                },
                "firstnamePlaceholder": "Votre prénom",
                "lastnamePlaceholder": "Votre nom",
                "emailPlaceholder": "Votre e-mail",
                "passwordPlaceholder": "Choisissez votre mot de passe",
                "passwordLegend": "6 caractères minimum",
                "schoolSearchEngineTitle": "Votre organisation est basée en France ?",
                "schoolByZipCodePlaceholder": "Code postal de votre organisation...",
                "schoolInOtherTerritoryTitle": "Votre organisation est basée dans un autre pays ?",
                "schoolFormTitle": "Mon organisation",
                "schoolSearch": "Cherchez votre organisation",
                "schoolInputsTitle": "ou\nsaisissez manuellement les coordonnées de votre organisation",
                "schoolNamePlaceholder": "Nom",
                "schoolAddressPlaceholder": "Adresse",
                "schoolZipCodePlaceholder": "Code postal",
                "schoolCityPlaceholder": "Ville",
                "schoolCountryPlaceholder": "Pays",
                "schoolinstitutionTypePrivate": "Privé",
                "schoolinstitutionTypePublic": "Public",
                "institutionTypePlaceholder": "Type d'organisation",
                "institutionFormTitle": "Mon organisation",
                "institutionNamePlaceholder": "Nom",
                "institutionAddressPlaceholder": "Adresse",
                "institutionZipCodePlaceholder": "Code postal",
                "institutionCityPlaceholder": "Ville",
                "institutionCountryPlaceholder": "Pays",
                "classesFormTitle": "De quel niveau scolaire\nvous occupez-vous ?",
                "animatorFunctionTitle": "Quel est votre rôle au sein de l'organisation ?",
                "animators": {
                    "args": {
                        "arg_1": {
                            "title": "500 activités",
                            "body": "clé-en-main à diffuser sur mobile, tablette ou ordinateur"
                        },
                        "arg_2": {
                            "title": "De courtes activités collectives",
                            "body": "Histoires audio, temps calmes, art & jeux d'impro, podcasts philo."
                        },
                        "arg_3": {
                            "title": "7 projets pédagogiques",
                            "body": "pour apprendre la confiance et le vivre ensemble dès 3 ans"
                        },
                        "arg_4": {
                            "title": "1 espace dédié",
                            "body": "à l’accompagnement des super-anims (formation, supports pédagogiques)"
                        },
                        "arg_5": {
                            "title": "Ressource soutenue par l’Education nationale",
                            "body": "Les compétences psychosociales au service du climat scolaire"
                        }
                    },
                    "organisationType": {
                        "title": "Précisez votre type d'organisation, s'il vous plait.",
                        "collectivity": "Collectivité",
                        "extrascollar": "Accueil périscolaire",
                        "social_center": "Centre social",
                        "edu_city": "Cité éducative",
                        "media_library": "Médiathèque",
                        "association": "Association",
                        "other": "Autre"
                    }
                },
                "family": {
                    "args": {
                        "arg_1": {
                            "title": "500 activités sans écran",
                            "body": "à diffuser sur mobile, tablette, et ordinateur"
                        },
                        "arg_2": {
                            "title": "Des activités audio et papier",
                            "body": "Histoires audio, temps calmes, art & jeux d'impro, podcasts philo"
                        },
                        "arg_3": {
                            "title": "7 super-parcours",
                            "body": "pour aider votre enfant à grandir en confiance"
                        },
                        "arg_4": {
                            "title": "LE PREMIER PROGRAMME PARENTAL",
                            "body": "conçu avec des chercheurs en neurosciences et psychologie"
                        },
                        "arg_5": {
                            "title": "SOUTENU PAR L’EDUCATION NATIONALE",
                            "body": "Les compétences psychosociales au service du climat scolaire"
                        }
                    }
                },
                "teachers": {
                    "args": {
                        "arg_1": {
                            "title": "6000 Super-profs",
                            "body": "qui font grandir la confiance et le vivre ensemble avec Lili"
                        },
                        "arg_2": {
                            "title": "500 activités clé-en-main",
                            "body": "à diffuser sur mobile, tablette, ordinateur ou TNI"
                        },
                        "arg_3": {
                            "title": "De courtes activités collectives",
                            "body": "Récits de rôles modèles, temps calmes, jeux d'art et impro, ateliers philo."
                        },
                        "arg_4": {
                            "title": "7 séquences pédagogiques",
                            "body": "pour développer une compétence psychosociale particulière"
                        },
                        "arg_5": {
                            "title": "1 espace dédié",
                            "body": "à l’accompagnement des enseignants (formation & supports pédagogiques)"
                        },
                        "arg_6": {
                            "title": "Soutenue par l’Education nationale",
                            "body": "ressource Edu-Up et TNE"
                        }
                    },
                    "functions": {
                        "teacher": "Enseignant/e",
                        "documentalist": "Professeur/e documentaliste",
                        "aesh": "AESH",
                        "atsem": "ATSEM",
                        "establishment_head": "Chef/fe d’établissement",
                        "medico_social": "Personnel médico-social",
                        "inspector": "Inspecteur/rice, conseiller/e ou référent/e",
                        "director_executive": "Autre directeur/rice ou cadre de l’Education nationale",
                        "other": "Autre"
                    }
                },
                "radioButtons": {
                    "coachManual": {
                        "firstPart": "Je souhaite recevoir gratuitement les conseils d'experts pour les super-parents, ",
                        "secondPart": "7 e-mails pour libérer les super-pouvoirs de votre enfant."
                    },
                    "family_newsletter": "Je souhaite recevoir des messages de Lili avec des conseils pour aider mon enfant à grandir en confiance et apaiser mon quotidien de parent",
                    "newsletter": "Je souhaite recevoir la newsletter et quelques messages de Lili pour m’accompagner à la prise en main de l’application.",
                    "classes": {
                        "kindergarten": "Maternelle",
                        "elementary": "Élementaire",
                        "middleschool": "Collège",
                        "highschool": "Lycée",
                        "other": "Autre (ex. SESSAD)",
                        "none": "Je ne m’occupe pas d’un niveau scolaire en particulier"
                    },
                    "animator": {
                        "animator": "Je suis animateur(rice)",
                        "specializedEducator": "Je suis éducateur(rice) spécialisé(e)",
                        "centerDirection": "Je suis directeur(rice) de centre",
                        "libraryDirector": "Je suis  directeur(rice) de médiathèque",
                        "collectivityDirection": "Je suis directeur(rice) ou personnel d'une collectivité",
                        "elected": "Je suis élu(e) ou adjoint(e)",
                        "other": "Autre"
                    }
                }
            },
            "buttons": {
                "search": "Rechercher",
                "steps": "OK",
                "thisWay": "C'est par ici",
                "signUp": "C'est parti !",
                "signIn": "Déjà inscrit(e) ?",
                "ok": "OK",
                "cgu": {
                    "firstPart": "L'inscription vaut pour acceptation des",
                    "secondPart": "conditions générales de l'application."
                }
            }
        }
    },
    "category": {
        "see_more": "Voir plus"
    },
    "choices": {
        "relax_title": "Ecoutez cette relaxation",
        "relax_without_music": "sans musique",
        "relax_with_music": "avec musique",
        "sleep_music_title": "Ecoutez cette musique",
        "sleep_music_with_intro": "avec une voix en introduction",
        "sleep_music": "sans aucune voix",
        "video": "Vidéo",
        "audio": "Audio",
        "synthesis": "Synthèse",
        "adapted_version": "En version adaptée",
        "original_version": "En version originale",
        "cps": {
            "audio": "Le podcast complet",
            "synthesis": "L'essentiel à retenir"
        }
    },
    "downloads": {
        "title": "Mes téléchargements",
        "empty": "Vous n'avez pas encore de téléchargement.\n\nPour en ajouter, appuyez sur le bouton téléchargement de vos activités."
    },
    "favorites": {
        "empty": "Vous n'avez pas encore de favoris.\n\nPour en ajouter, appuyez sur le bouton ♡ de vos activités préférées.",
        "title": "Mes favoris"
    },
    "filters": {
        "cycle1": "3-6 ans",
        "cycle2": "6-11 ans",
        "cycle3": "11-15 ans"
    },
    "levels": {
        "cycle1": "Maternelle",
        "cycle2": "Élémentaire",
        "cycle3": "Collège"
    },
    "giftcards": {
        "title": "Mes cartes Premium"
    },
    "keys": {
        "superAdultUsers": {
            "family": "Super-parents",
            "teacher": "Super-profs",
            "doctor": "Super-médecins",
            "animator": "Super-anims",
            "unknown": "Super-adultes"
        }
    },
    "media": {
        "toDownload": "À télécharger",
        "toPrint": "À imprimer",
        "philoNotebook": "Carnet",
        "podcast": "Podcast",
        "toListen": "À écouter",
        "preview": "Aperçu",
        "toWatch": "À voir"
    },
    "mood": {
        "title": "Ma météo intérieure",
        "subtitle": "Quel temps fait-il à l’intérieur de toi ? Soleil car tu te sens joyeux, pluie car tu te sens triste ? Choisis la météo de ton profil !",
        "buttonTitle": "OK",
        "happy": "joyeux(se)",
        "peaceful": "calme",
        "sad": "triste",
        "annoyed": "mécontent(e)",
        "stressed": "stressé(e)",
        "angry": "en colère"
    },
    "onboarding": {
        "buttons": {
            "signUp": "Je m'inscris",
            "signIn": "Déjà inscrit(e) ?"
        },
        "teacher": {
            "pageOne": {
                "title": "Conçue par des enseignants\npour les enseignants",
                "subtitle": "Inspirée des pédagogies Montessori et Freinet",
                "legend": "Maternelle - Elémentaire - Début du collège"
            },
            "pageTwo": {
                "title": "200 Ateliers pour la classe"
            },
            "pageThree": {
                "title": "Des ressources pour l'enseignant",
                "classMaterial": "Matériel pour la classe",
                "schoolMaterial": "Supports pédagogiques",
                "linkSheets": "Fiches de liaison",
                "formationModules": "Modules de formations",
                "teacherFacebook": {
                    "title": "Groupe facebook",
                    "subtitle": "La salle des profs Lili à l'école"
                }
            },
            "pageFour": {
                "title": "Paroles de super-profs",
                "sylvieDEsclaibes": {
                    "title": "\"Lili répond à un vrai besoin pour les enseignants\"",
                    "subtitle": "Sylvie d'Esclaibes, pionnière de l'éducation Montessori en France"
                },
                "nadine": {
                    "title": "\"Super application pédagogique, facile d'appropriation. Les élèves sont demandeurs\"",
                    "subtitle": "Nadine, directrice d'école primaire"
                },
                "severine": {
                    "title": "\"Mes élèves adorent les relaxations. Comme elles sont courtes, ça me permet de garder tout le monde calme et attentif.\"",
                    "subtitle": "Séverine, enseignante de maternelle"
                },
                "armelle": {
                    "title": "\"Des référents pédagogiques de renom\"",
                    "subtitle": "Armelle, présidente de Public Montessori"
                },
                "claire": {
                    "title": "\"L'éducation au bien-être\"",
                    "subtitle": "Claire, enseignante du CM2"
                }
            }
        },
        "parent": {
            "pageOne": {
                "title": "Bien plus qu'une appli audio\nune pédagogie active et ludique",
                "subtitle": "inspirée de Montessori et Freinet",
                "legend": "Relaxation & Yoga - Arts & Impro - Philo pour enfants"
            },
            "pageTwo": {
                "title": "200 Ateliers pour la classe"
            },
            "pageThree": {
                "title": "Pour le super-héros",
                "routines": {
                    "title": "Routine de super-héros",
                    "day": {
                        "title": "Le jour",
                        "subtitle": "Parcours d'entraînement\nde super-héros"
                    },
                    "night": {
                        "title": "Le soir",
                        "subtitle": "Relaxation\npour s'endormir"
                    }
                },
                "ressources": {
                    "title": "7 super-parcours",
                    "activities": "Avec ateliers",
                    "talk": "Arts et\nimprovisation",
                    "grow": "Podcasts et\ncarnets philo",
                    "still": "Relaxation\net yoga",
                    "tools": "Et matériels créatifs"
                }
            },
            "pageFour": {
                "title": "Pour les super-parents",
                "coachManual": {
                    "part_one": "Recevez-le par e-mail et retrouvez-le",
                    "part_two": "dans le menu",
                    "part_three": "de l'appli"
                },
                "tools": {
                    "school": {
                        "title": "Matériel pédagogique",
                        "body": "pour accompagner\nvotre super-héros"
                    },
                    "experts": {
                        "title": "Conseils d'experts",
                        "body": "en pédagogie et en\nSciences de l'éducation"
                    }
                },
                "citation": {
                    "text": "\"Avec Lili, nous donnons des clés de confiance à chaque enfant. Parce que la confiance, ça se transmet !\"",
                    "legend": "Arnaud, CEO de Lili et coach de 3 super-héros"
                }
            }
        }
    },
    "pdf": {
        "errorTitle": "Oups !",
        "errorBody": "Il semble qu'une erreur se soit produite au chargement de votre fichier.",
        "errorRetryButton": "Réessayer"
    },
    "premium": {
        "title": {
            "teacher": "Lili pour les super-profs premium",
            "animator": "Lili pour les super-anims premium",
            "family": "Lili premium"
        },
        "our_plans": "Nos formules",
        "finance": "Comment financer le programme",
        "cards": "Cartes premium",
        "premium_cards": {
            "title": "Activer une carte premium",
            "body": "Vous avez reçu un code",
            "button": "Activer une carte premium"
        },
        "animator": {
            "feedback": {
                "title": "Ce que ses bénéficiaires pensent de Lili *",
                "legend": "* Évaluation d'impact auprès de 60 enseignants et protocole avec l'Académie de Nancy-Metz",
                "args": {
                    "one": "Lili s'inscrit dans les programmes : Français, EMC, HVC...",
                    "two": "Lili améliore significativement le climat éducatif",
                    "three": "Lili favorise l’inclusion et répond aux besoins éducatifs spécifiques"
                }
            },
            "minister_section": {
                "chapo": "3-15 ans"
            },
            "plans": {
                "intro": {
                    "title": "Déployer un projet sur les compétences psychosociales en périscolaire, accueil de loisirs et centre social pour :",
                    "bullet": {
                        "one": "Renforcer l’estime de soi des enfants et des jeunes",
                        "two": "Prévenir le harcèlement et développer le vivre-ensemble",
                        "three": "Promouvoir l’inclusion avec des récits de rôles modèles",
                        "four": "Favoriser la montée en compétences et le bien-être des animateurs",
                        "five": "Soutenir la parentalité avec Lili à la maison",
                        "six": "des podcasts sur la posture : \"Sensibilisation aux CPS\" et \"Ateliers philo\"",
                        "seven": "un module \"Bien-être des super-anims\""
                    },
                    "button": "Voir le détail du programme"
                },
                "acm": {
                    "title": "LICENCE ACM",
                    "body": "Outiller les animateurs et les référents familles avec l’application audio “sans écran” et la mallette des super-anims (en option) :\n7 projets d’animation clé-en-main, les plannings pour le périscolaire et les mercredis/vacances, des modules pour développer la posture ou le bien-être des animateurs.",
                    "button": "Nous contacter"
                },
                "complet_program": {
                    "body": "Outiller et former la communauté éducative (familles comprises) pour mettre en œuvre un parcours en coéducation :"
                }
            }
        },
        "family": {
            "plans": {
                "intro": {
                    "title": "Le 1er programme des parents conçu avec les neurosciences et soutenu par l’Education nationale",
                    "button": "Je démarre ma semaine gratuite"
                },
                "details": {
                    "title": "DES CONSEILS D’EXPERTS EN NEUROSCIENCES ET PSYCHOLOGIE ET 7 SUPER-PARCOURS POUR AIDER VOTRE ENFANT À :",
                    "buttons": {
                        "free_week": "Je démarre ma semaine gratuite",
                        "no_free_week": "Je m'abonne"
                    },
                    "bullet": {
                        "one": "s’apaiser et mieux gérer ses émotions",
                        "two": "se concentrer pour les devoirs",
                        "three": "profiter d’un temps calme avec les histoires audio avant le coucher",
                        "four": "s’endormir plus facilement, loin des écrans",
                        "five": "retrouver confiance en cas de stress scolaire, dépasser sa timidité et prendre la parole",
                        "six": "discuter du quotidien (émotions, amitié, moquerie, etc.).",
                        "seven": "un programme Bien-être des super-parents",
                        "height": "des clés pour comprendre votre enfant à chaque âge, l'aider à grandir en confiance et vivre plus sereinement votre quotidien de parent."
                    }
                }
            }
        },
        "teacher": {
            "support": {
                "title": "UN PROGRAMME CONÇU AVEC LE SOUTIEN DE LA RECHERCHE ET DE L’ÉDUCATION NATIONALE",
                "teams": {
                    "one": "COMPÉTENCES PSYCHOSOCIALES",
                    "two": "NEUROSCIENCES",
                    "three": "PHILOSOPHIE POUR ENFANTS"
                }
            },
            "feedback": {
                "title": "Ce que les enseignants pensent de Lili *",
                "legend": "* Évaluation d'impact auprès de 60 enseignants et protocole avec l'Académie de Nancy-Metz",
                "args": {
                    "one": "Lili s'inscrit dans les programmes : Français, EMC, HVC...",
                    "two": "Lili améliore significativement le climat scolaire",
                    "three": "Lili favorise l’inclusion et répond aux besoins éducatifs particuliers"
                }
            },
            "minister_section": {
                "title": "Le programme de développement des compétences psychosociales et langagières en milieu scolaire et périscolaire, avec un volet de soutien à la parentalité",
                "chapo": "Maternelle • Élémentaire • Collège",
                "body": "Conçu avec le soutien de la Recherche et de l’Éducation nationale"
            },
            "finance": {
                "district": {
                    "title": "QPV, Cités éducatives et TER",
                    "body": "Votre établissement fait partie d’un Quartier Prioritaire de la Ville, d'une Cité éducative ou d’un Territoire éducatif rural ? Co-construisons un projet sur mesure en continuité éducative.",
                    "button": "Co-construire un projet"
                },
                "divers": {
                    "title": "Divers financements possibles",
                    "body": "Vous portez un projet innovant, qui, comme Lili, vise à améliorer la réussite et le bien-être des élèves ou qui favorise la coéducation avec les familles ? Divers dispositifs peuvent financer le programme Lili.",
                    "button": "Nous contacter"
                }
            },
            "plans": {
                "teacher": {
                    "title": "Licence enseignant",
                    "body": "S’outiller avec des séquences pédagogiques, des programmations et des activités adaptées à chaque niveau + 12h de modules d’auto-formation.",
                    "button": "Je souscris à Lili pour les super-profs Premium",
                    "extra": "Voir le détail"
                },
                "school": {
                    "title": "Licence établissement",
                    "body": "Outiller l’équipe éducative (enseignants, ATSEM, AESH, infirmière scolaire, AED…) de votre école ou collège avec l’application audio “sans écran” et, en option, la mallette des super-profs, pour déployer un projet sur les compétences psychosociales.",
                    "button": "Nous contacter"
                },
                "complet_program": {
                    "title": "Programme complet",
                    "body": "Outiller et former la communauté éducative (familles comprises) pour mettre en œuvre un parcours en cohérence avec le projet de l’établissement :",
                    "button": "Voir le détail du programme"
                },
                "details": {
                    "title": "SOUTENU PAR L’ÉDUCATION NATIONALE ET DÉJÀ ADOPTÉ PAR 6000 COLLÈGUES DE LA MATERNELLE AU COLLÈGE, “LILI POUR LES SUPER-PROFS” :",
                    "buttons": {
                        "free_week": "Je démarre ma semaine gratuite",
                        "no_free_week": "Je souscris"
                    },
                    "bullet": {
                        "one": "développe les compétences psychosociales et langagières de vos élèves",
                        "two": "renforce leur estime de soi et la persévérance",
                        "three": "s’inscrit facilement dans votre emploi du temps : Français, EMC, HVC…",
                        "four": "améliore significativement le climat de classe et prévient le harcèlement",
                        "five": "favorise l’inclusion et répond aux besoins éducatifs particuliers",
                        "six": "répond aux enjeux de bien-être et santé mentale, d’égalité filles-garçons, ou de citoyenneté",
                        "seven": "des modules d’auto-formation : “Sensibilisation aux CPS” et “Ateliers philo”",
                        "height": "un module \"Bien-être des super-profs\""
                    }
                }
            }
        }
    },
    "preview": {
        "author": "Auteur",
        "editor": "Éditeur",
        "age": "Âge"
    },
    "profile": {
        "giftCards": "Mes cartes Premium",
        "admin": "Super Admin",
        "title": "Mon profil",
        "myAccount": "Mon compte",
        "myFormule": "Ma formule",
        "myWeather": "Ma météo",
        "subscription": "Passer\nPremium",
        "code": "J'ai un code",
        "filtersByLevel": {
            "teacher": "Mon niveau",
            "family": "Ma tranche d'âge",
            "animator": "Ma tranche d'âge"
        },
        "filtersByLevelTeachers": "Mon niveau de classe",
        "subYearAvailability": "Valide pour l'année scolaire : %{year}",
        "subAvailability": "Date de fin",
        "liliAsAGift": "Offrir LILI",
        "subCards": "Cartes Premium",
        "subCardsBody": "Activer une carte Premium",
        "myVictories": "Mes récompenses",
        "myDownloads": "Mes téléchargements",
        "myFavorites": "Mes favoris",
        "myReview": "Mon avis",
        "logout": "Me déconnecter",
        "deleteMyAccount": "Supprimer mon compte",
        "unsubscribe": "Se désabonner",
        "unsubscribeTitle": "Vous souhaitez mettre fin à votre abonnement ?",
        "unsubscribeAndroidBody": "Vous pouvez annuler votre abonnement en appuyant sur le bouton \"Gérer mon abonnement\" ci-dessous.",
        "unsubscribeiOSBody": "Vous pouvez annuler votre abonnement en appuyant sur le bouton \"Gérer mon abonnement\" ci-dessous.",
        "unsubscribeFromWeb": "En confirmant votre demande de résiliation à Lili pour les super-parents Premium, votre abonnement s’arrêtera à sa date de fin. Vous n’aurez alors plus accès à l’intégralité des super-activités pour faire grandir pleinement la confiance de votre super-héros 🙁",
        "unsubscribeAndroidFromiOSBody": "Il semble que vous vous soyez abonné sur Android.\nVous pouvez annuler votre abonnement dans la rubrique Abonnements du Google Play Store.",
        "unsubscribeFromLili": "Votre abonnement vous a été offert par LILI ! Il serait dommage de l'abandonner !",
        "unsubscribeCancel": "Annuler",
        "unsubscribeConfirmation": "Confirmer",
        "showSubscriptionManagement": "Gérer mon abonnement",
        "unsubscribeSuccessTitle": "C'est fait !",
        "unsubscribeSuccessBody": "Le renouvellement automatique de ton abonnement est annulé, et celui-ci prendra fin le %{date}.",
        "unsubscribeErrorTitle": "Aïe !",
        "unsubscribeErrorBody": "Une erreur est survenue lors de l'annulation de ton abonnement. Pour que nous puissions t'aider, contacte-nous : support@lili.cool",
        "freeVersion": "Découverte",
        "demoVersion": "Démo",
        "premiumVersion": "Premium",
        "abo_family": "Lili pour les super-parents",
        "abo_teacher": "Lili pour les super-profs",
        "abo_animator": "Lili pour les super-anims",
        "duration": "Durée",
        "months": "mois",
        "days": "jours",
        "teacher_non_renewable": "Votre licence ne sera pas automatiquement reconduite à cette date"
    },
    "startingSteps": {
        "title": "Nouveau sur Lili ?",
        "subtitle": "Suivez les %{number_of_steps} étapes pour vous lancer",
        "button": "Lancez-vous !",
        "macaroon": "C'est\npar ici",
        "modal": {
            "title": "%{number_of_steps} étapes pour vous lancer",
            "button": "Fermer"
        }
    },
    "subCards": {
        "title": "Cartes Premium",
        "no_cards": "Vous n’avez pas de carte Premium\nà activer ou à transférer.",
        "card": {
            "used": "Carte utilisée"
        },
        "modal": {
            "already": " Vous avez déjà un compte Premium. Vous ne pouvez donc pas utiliser cette carte pour vous.",
            "form": {
                "redeemed": "Votre carte est activée.\nVous bénéficiez dès à présent de votre abonnement.",
                "title": "Activer une carte PREMIUM",
                "body": "Vous avez reçu un code pour activer un abonnement LILI PREMIUM ?\n\nVous pouvez le saisir dans le champ ci-dessous pour associer l'abonnement à votre compte.",
                "active": "Activer",
                "nothingToDo": "Ne rien faire pour l'instant",
                "close": "Fermer"
            },
            "valid": {
                "title": "Que souhaitez-vous faire avec votre carte Premium ? ",
                "body": "Vous pouvez l'utiliser accéder à l'intégralité de LILI avec votre compte ou la transférer à un autre utilisateur de LILI.",
                "redeemed": "Activer la carte Premium sur mon compte",
                "nothingToDo": "Ne rien faire pour l'instant",
                "transfer": "Transférer la carte Premium à un autre utilisateur"
            },
            "redeemed": {
                "title": "Votre carte Premium a déjà été utilisée.",
                "body": "Cette carte Premium a été affectée à un autre utilisateur et ne peut donc plus être utilisée.",
                "close": "Fermer"
            },
            "transfer": {
                "title": "Vous souhaitez transférer cette carte Premium",
                "body": "Vous pouvez offrir cette carte Premium à un autre utilisateur en saisissant son adresse e-mail ci-dessous.",
                "cancel": "Annuler",
                "send": "Envoyer",
                "email": "Adresse e-mail du destinataire"
            }
        },
        "post_action": {
            "validation": {
                "title": "Carte Premium activé !",
                "body": "Votre compte est maintenant Premium! Bonne utilisation de LILI !"
            },
            "transfert": {
                "title": "Carte Premium transféré !",
                "body": "Votre carte Premium a bien été tranférée à l'adresse : %{email}\nLe destinataire a reçu un e-mail pour lui expliquer comment en bénéficier."
            }
        }
    },
    "subscription": {
        "animator": {
            "title": "Choisissez la meilleure formule Premium pour votre centre",
            "offers": {
                "title": "Lili pour les super-anims",
                "body": "Profitez en illimité des  400 activités pour votre centre et de l’intégralité de l’accompagnement dont le module de formation aux ateliers philo."
            },
            "subscribed": {
                "title": "Votre formule",
                "duration": "Lili pour les super-anims",
                "body": "Vous profitez en illimité des 400 activités pour votre centre et de l’intégralité de l’accompagnement dont le module de formation aux ateliers philo."
            },
            "legalMentions": "La formule Premium s’arrête automatiquement à la fin de la période.",
            "subscribe": "Je souscris",
            "restore": "J’ai déjà une licence !"
        },
        "teacher": {
            "title": "Choisissez la meilleure formule Premium pour votre classe",
            "offers": {
                "title": "Lili pour les super-profs",
                "body": "Profitez en illimité des 400 activités pour la classe et de l’intégralité des supports pédagogiques"
            },
            "subscribed": {
                "title": "Votre formule",
                "duration": "Lili pour les super-profs",
                "body": "Vous profitez en illimité des 400 activités pour la classe et de l’intégralité des supports pédagogiques"
            },
            "legalMentions": "La formule Premium s’arrête automatiquement à la fin de la période.",
            "subscribe": "Je souscris",
            "restore": "J’ai déjà une licence !"
        },
        "parent": {
            "title": "Les crises, les devoirs, le coucher : des solutions concrètes pour votre quotidien de parent.",
            "offers": {
                "title": "LILI POUR LES SUPER-PARENTS",
                "body": "Des conseils d'experts en neurosciences et psychologie pour comprendre votre enfant à chaque âge, l'aider à grandir en confiance et vivre plus sereinement votre quotidien de parent."
            },
            "subscribed": {
                "title": "Votre abonnement",
                "duration": "LILI POUR LES SUPER-PARENTS",
                "body": "Vous accédez en illimité à des conseils d'experts en neurosciences et psychologie pour comprendre votre enfant à chaque âge, l'aider à grandir en confiance et vivre plus sereinement votre quotidien de parent.",
                "legalMentions": {
                    "renewable": "Votre abonnement sera reconduit automatiquement à cette date.",
                    "notRenewable": "Votre abonnement ne sera pas reconduit automatiquement à cette date."
                }
            },
            "legalMentions": "Sans engagement. Résiliable à tout moment.",
            "testPeriod": "Essai gratuit pendant 1 semaine puis",
            "subscribe": "Je démarre ma semaine gratuite",
            "restore": "Je suis déjà abonné !"
        },
        "buttons": {
            "more": "En savoir plus",
            "hide": "Fermer",
            "unsubscribe": "Me désabonner",
            "startWithPremium": "Profitez de LILI en Premium",
            "goBackHome": "Retourner à la page d'accueil"
        }
    },
    "superAdmin": {
        "sub": "Abonnement",
        "subOff": "Désactiver mon abonnement",
        "subOn": "Réactiver mon abonnement",
        "title": "SUPER ADMIN HQ",
        "users": "Gestion des utilisateurs",
        "gifts": "Offrir LILI",
        "bugs": "Remonter un bug",
        "editionMode": "Mode ADMIN",
        "teacherProfileMode": "Profil enseignant",
        "animatorProfileMode": "Profil animateur",
        "familyProfileMode": "Profil parent",
        "tneStat": "Statistique TNE",
        "quotes": "Citations",
        "offlineMode": "Mode offline"
    },
    "superPowersPlaylist": {
        "loading": "Lancement en cours…",
        "titles": {
            "equipment": "Pour t'équiper",
            "warmUp": "Pour t'échauffer",
            "training": "Pour t'entraîner"
        }
    },
    "superPowers": {
        "emotionsTaming": {
            "body": {
                "fr": [
                    "En 2011, des chercheurs de Harvard ont montré que la pratique d'un temps calme densifie la matière grise du cerveau dans l’hippocampe (connu pour son rôle dans l’apprentissage et la mémoire) et la fait diminuer dans l’amygdale (impliquée dans la production du stress). Depuis, Grégory Michel, professeur de psychologie clinique, a mené une étude à l'école : l'intensité de l’anxiété des enfants diminue, améliorant ainsi le bien-être collectif et les relations en classe.",
                    "Les résultats du programme d’éducation à l’empathie mené par Omar Zanna en 2014, docteur en sociologie et psychologie, rappellent également que les émotions se vivent et s’intègrent corporellement ; il est essentiel de mobiliser le corps pour se les approprier. Des études ont enfin montré que les ateliers de philosophie pour enfants améliorent le contrôle émotionnel et induisent une plus grande cohésion sociale."
                ]
            }
        },
        "focus": {
            "body": {
                "fr": [
                    "Le trouble déficit de l’attention touche 3 à 5 % des enfants, dû à un dysfonctionnement des mémoires à court terme. Si la difficulté à se concentrer concerne un nombre grandissant d'enfants, heureusement “l'attention s'apprend”, affirme le neurobiologiste Jean-Philippe Lachaux, \"malgré et avec l’écran\". Ce que permet Lili, avec la pratique d’activités qui aiguisent l’attention sur un temps court, au format audio.",
                    "Selon Lachaux, si on se déconcentre du fait de pensées parasites (un souci, une chose à faire, une envie, un souvenir) ou de perceptions extérieures (un bruit, une conversation), on peut apprendre à se concentrer en découpant chaque objectif en une suite de tâches à confier à des \"mini-moi\" successifs polarisés sur une seule consigne. À la fin de la séquence, son \"maxi-moi\" reprend la main et planifie la séquence suivante, avec à ce moment-là le droit de se laisser divertir par ses pensées ou le monde extérieur."
                ]
            }
        },
        "errorTaming": {
            "body": {
                "fr": [
                    "\"Apprendre ce n’est pas faire grossir son cerveau, c'est un processus dynamique non linéaire\", explique le chercheur en psychologie et neurosciences Grégoire Borst. \"Les erreurs sont aussi importantes que les réussites : c’est de leur logique que se déduisent les facteurs de progrès\", insiste Olivier Houdé, enseignant-chercheur et psychologue. Pour accompagner les enfants dans cette démarche d’acceptation de l’erreur, il faut valoriser leur état d'esprit de développement (le \"growth mindset\") théorisé par la psychologue Carol Dweck.",
                    "Ne pas survaloriser la performance, mais plutôt louer l'effort, l'approche, les progrès, afin que l’enfant prenne conscience d'être sur un chemin d'apprentissage. Remplacez la formule \"je n'y arrive pas\" par \"je n'y arrive pas… encore !\", sous-entendu \"j'y arriverai un jour\", et l'enfant s'implique, il corrige l'erreur et apprend d'elle."
                ]
            }
        },
        "speak": {
            "body": {
                "fr": [
                    "Dans son rapport \"Faire du grand oral un levier de l'égalité des chances\", Cyril Delhay, professeur d'art oratoire, affirme que l'enseignement de l’oral peut être vecteur d'égalité sociale. La maîtrise de l'oral fait effectivement la différence dans les études et la vie professionnelle, or c'est un art très ouvert socialement qui demande peu de pré-requis culturels. Investir sur l'oral, c'est ouvrir la voie à une meilleure qualité d'écoute et de vie en collectivité, et œuvrer pour la réussite éducative de tous.",
                    "\"Savoir parler est partageable à tous les publics, et particulièrement bénéfique à l’école pour les enfants socialement défavorisés qui ne peuvent apprendre par mimétisme à la maison\", conclut Cyril Delhay."
                ]
            }
        },
        "collective": {
            "body": {
                "fr": [
                    "La pratique théâtrale a une véritable fonction sociale. Une étude de 2013 l’expose comme un outil efficace pour apprendre à se connaître, à faire avec les autres et à vivre-ensemble en dépassant les conflits. Philippe Osmalin, metteur en scène formateur et enseignant, compare les séances théâtrales à des mailles de la construction de soi par le tissage collectif.",
                    "Dans le prolongement des jeux d’improvisation qui aident à la socialisation, le questionnement lors d’un atelier de philosophie permet de déconstruire les idées reçues et s'ouvrir aux autres avec empathie. On apprend à être en désaccord sans se disputer, on comprend mieux son comportement et celui des autres. Selon les économistes Yann Algan et Pierre Cahuc, \"l’apprentissage de la coopération avec des travaux en groupe et la participation à des débats civiques\" est un facteur déterminant du bien-être et de la réussite éducative. Ce que corroborent les enquêtes PISA."
                ]
            }
        },
        "criticalThinking": {
            "body": {
                "fr": [
                    "\"Il n'y a pas d'âge pour se poser des questions philosophiques : le premier humain avait-il une maman (sur les origines), pourquoi tout le monde ne parle pas comme nous (sur le langage), doit-on être gentil avec les méchants (sur le bien le mal) ?\", explique Edwige Chirouter, professeure des universités et chercheure en philosophie pour enfants. Selon Grégoire Borst et Olivier Houdé, chercheurs et psychologues, la curiosité ou le doute, propices au questionnement, sont des émotions subtiles et positives qui permettent au cerveau de bloquer nos pensées automatiques pour activer une pensée rationnelle et logique.",
                    "Lors des ateliers de philosophie, il s’agit de créer un cadre dans lequel on doit justifier ses opinions. Il a été prouvé que ce dialogue stimule l’engagement avec le sujet traité et a des effets cognitifs positifs sur la scolarité, impactant les résultats dans les matières traditionnelles, en mathématiques notamment."
                ]
            }
        },
        "selfEsteem": {
            "body": {
                "fr": [
                    "Le théoricien Stanley Coopersmith a montré la non-corrélation entre l'estime de soi de l'enfant et la fortune, l'éducation ou la profession des parents : ce qui prime c’est la qualité de la relation avec ses parents. La psychologue Susan Harter a ajouté l'importance de l’approbation de ses parents, puis peu à peu de ses pairs. Encourager, valoriser, aider à bien grandir : c'est le rôle de chaque éducateur de donner ces clés de confiance et de réussite, et la mission que s’est donnée Lili à leur côté, en permettant un enseignement des compétences psychosociales basé sur l'expérimentation, ludique et valorisant.",
                    "Plusieurs études ont par ailleurs mis en évidence les effets positifs des ateliers de philosophie sur le comportement à l’école. Expérimenter l'écoute active et se sentir écouté renforce l'estime de soi, la confiance en soi et la motivation. Deux études ont démontré une efficacité élevée et constante en termes de gain cognitif, de développement socio-émotionnel et de réussite scolaire."
                ]
            }
        }
    },
    "tags": {
        "emotionsTaming": "Apprivoiser\nmes émotions",
        "focus": "Muscler\nma concentration",
        "errorTaming": "Dompter\nl'erreur",
        "speak": "Oser\nà l'oral",
        "collective": "La jouer\ncollectif",
        "criticalThinking": "Réfléchir\nsur la vie",
        "selfEsteem": "Croire\nen moi"
    },
    "teacherForm": {
        "title": "Bénéficiez de Lili à l'école pour votre classe avec les Petits champions de la lecture",
        "body": "Inscrivez-vous aujourd'hui et bénéficiez de 1 mois d'abonnement à Lili à l’école : bien + qu'une appli audio, c'est un programme complet d’ateliers de relaxation, d’improvisation et de philo pour enfants, accompagnés de supports pédagogiques, spécifiquement conçus par une équipe d’experts et d’enseignants, pour les enseignants de maternelle, de l’élémentaire et du début du collège. Vous trouverez également des ateliers pour travailler la lecture à l'oral en classe, co-construits avec les Petits champions de la lecture.",
        "error": {
            "allFieldsAreMandatory": "Tous les champs du formulaire sont obligatoires.",
            "default": "Une erreur est survenue.",
            "impossibleSubscription": "Inscription impossible",
            "tooShortPassword": "Votre mot de passe ne contient pas assez de caractères !",
            "addressAlreadyInUse": {
                "body": "Votre e-mail appartient déjà à notre base. Si vous avez déjà un compte, cliquez sur le bouton \"Attention : si vous avez déjà un compte...\" au dessus du formulaire, pour bénéficier d'un mois d'abonnement gratuit sur votre compte LILI.",
                "title": "E-mail déjà existant."
            }
        },
        "success": {
            "signUp": {
                "title": "Bienvenue chez LILI !",
                "body": "Dès maintenant, vous pouvez installer LILI sur votre téléphone, et commencer à bénéficier de votre mois d'abonnement gratuit."
            },
            "signIn": {
                "title": "Découvrez votre nouvel abonnement !",
                "body": "Dès maintenant, vous pouvez bénéficier de votre mois d'abonnement gratuit."
            }
        },
        "form": {
            "title": "Profitez d’1 mois offert",
            "signUp": {
                "createYourAccount": "Créez votre compte Lili"
            },
            "signIn": {
                "connect": "Connectez-vous à votre compte Lili"
            },
            "emailPlaceholder": "Votre e-mail",
            "signUpPasswordPlaceholder": "Choisissez votre mot de passe",
            "signInPasswordPlaceholder": "Votre mot de passe",
            "schoolNamePlaceholder": "Nom de votre établissement",
            "zipCodePlaceholder": "Code postal de votre établissement",
            "button": {
                "signUp": "C'est parti !",
                "signIn": "C'est parti !",
                "alreadyRegistered": "Attention : si vous avez déjà un compte, cliquez ici pour préciser vos identifiants Lili et bénéficier d'un abonnement Premium",
                "noAccount": "Vous n'avez pas encore de compte ? Inscrivez-vous",
                "newsletter": "Je souhaite recevoir la newsletter et quelques messages de Lili pour m’accompagner à la prise en main de l’application."
            }
        }
    },
    "userRewards": {
        "myRainbows": "Mes arcs-en-ciel gagnés",
        "myDays": "Mes jours d'affilée",
        "myBadges": "Mes badges gagnés",
        "seeAllDiscoveryBadges": "Voir tous les badges découverte",
        "hideAllDiscoveryBadges": "Masquer les badges découverte",
        "seeAllFidelityBadges": "Voir tous les badges fidélité",
        "hideAllFidelityBadges": "Masquer les badges fidélité",
        "seeAllEventsBadges": "Voir tous les badges évènements",
        "hideAllEventsBadges": "Masquer les badges évènements",
        "Ihelp": "j'aide Lili",
        "Ishare": "je partage",
        "Igive": "je donne",
        "Isponsor": "je parraine",
        "noBadgesBody": "Retrouve ici\nta collection de badges\nà imprimer en version coloriage !",
        "howToGainBadges": "Comment gagner des badges ?",
        "howToGainBadgesBody": "Activité après activité, gagne des points et\najoute des couleurs à ton arc-en-ciel.\n\nCela te permettra aussi de gagner\ndes badges à colorier.\n\nCi-dessous tu as la description de ce que tu dois\nfaire pour remporter chacun des badges.",
        "letsGo": "C'est parti !",
        "badge_melomane": "Mélomane",
        "badge_expressif": "Expressif",
        "badge_audacieux": "Intrépide",
        "badge_aventurier": "Aventurier(e)",
        "badge_joueur": "Joueur",
        "badge_courageux": "Téméraire",
        "badge_agile": "Agile",
        "badge_grand_lecteur": "Littéraire",
        "badge_pose": "Calme",
        "badge_repose": "Détendu(e)",
        "badge_intellectuel": "Intellectuel(le)",
        "badge_curieux": "Curieux",
        "badge_collectionneur": "Loyal(e)",
        "badge_reveur": "Rêveur",
        "badge_tranquille": "Tranquille",
        "badge_serein": "Serein(e)",
        "badge_maitre_zen": "Zen",
        "badge_comedien": "Comédien(ne)",
        "badge_star": "Star",
        "badge_roi_de_la_scene": "Roi de la scène",
        "badge_enqueteur": "Détective",
        "badge_explorateur": "Explorateur",
        "badge_grand_sage": "Philosophe",
        "body": {
            "0124": "Accès au programme \"Lili à l'école\" lors de la journée de l'éducation",
            "0308": "Podcast philo \"Fille, garçon : c'est différent ?\" lors de la journée internationale des droits de la femme",
            "0321": "Podcast philo \"Nous sommes tous pareils ?\" lors de la journée pour l'élimination de la discrimination raciale",
            "0406": "Podcast philo \"L'important, c'est de participer ?\" lors de la journée du sport au service du développement et de la paix",
            "0421": "Improvisation ou mime lors de la journée de la créativité et de l’innovation",
            "0621": "Atelier de yoga lors de la journée internationale du yoga",
            "0730": "Podcast philo \"Ça veut dire quoi, un ami ?\" lors de la journée de l'amitié",
            "0921": "Relaxation lors de la journée de la paix",
            "0922": "Pratique de Lili le jour de la date anniversaire de l'application (Lili a été lancée le 22 septembre 2020)",
            "1031": "Podcast philo \"J'ai peur !\" le jour de Halloween",
            "1105": "Podcast philo \"Ça va, on rigole !\" lors de la journée de lutte contre le harcèlement",
            "1203": "Podcast philo \"Ça veut dire quoi, normal ?\" lors de la journée des personnes handicapées",
            "badge_melomane": "Une bulle sonore et un atelier de yoga en musique",
            "badge_expressif": "Mime \"Alphabet visuel\" et jeu d’émotion \"La valse des émotions\"",
            "badge_audacieux": "Improvisation \"Super, j’ai raté !\" et podcast philo \"Mince, j’ai fait une erreur !\"",
            "badge_aventurier": "Relaxation \"L’île intérieure\" et respiration \"La montgolfière\"",
            "badge_joueur": "Dessin à dédicacer \"Victoire !\" et podcast philo \"L’important, c’est de participer ?\"",
            "badge_courageux": "Improvisation \"Attention à la chute !\" et dessin à dédicacer \"Même pas peur !\"",
            "badge_agile": "Réaliser au moins une activités de chacune des 4 sections \"Mes programmes\", \"Je me pose\", \"Je m’exprime\" et \"Je grandis\"",
            "badge_grand_lecteur": "Lecture de plus de 10 conseils de lecture depuis \"Je grandis\"",
            "badge_pose": "Un origami, un dessin à dédicacer et un carnet philo",
            "badge_repose": "Pratique d’une activité \"Je me pose\" un samedi et un dimanche",
            "badge_intellectuel": "Jeu d'attention \"Jeu de mémoire\" et podcast philo \"Ça veut dire quoi, être intelligent ?\"",
            "badge_curieux": "Pratique d’une activité de chaque catégorie",
            "badge_collectionneur": "Pratique de 4 ateliers au sein d’une catégorie",
            "badge_reveur": "Bulle sonore \"La plage\" et dessin à dédicacer \"Je me souviens\"",
            "badge_tranquille": "Pratique de 3 ateliers \"Je me pose\"",
            "badge_serein": "Pratique de 10 ateliers \"Je me pose\"",
            "badge_maitre_zen": "Pratique de 20 ateliers \"Je me pose\"",
            "badge_comedien": "Pratique de 3 ateliers \"Je m'exprime\"",
            "badge_star": "Pratique de 10 ateliers \"Je m'exprime\"",
            "badge_roi_de_la_scene": "Pratique de 20 ateliers \"Je m'exprime\"",
            "badge_enqueteur": "Pratique de 3 ateliers \"Je grandis\"",
            "badge_explorateur": "Pratique de 10 ateliers \"Je grandis\"",
            "badge_grand_sage": "Pratique de 20 ateliers \"Je grandis\""
        },
        "owned": {
            "0124": "Tu as consulté le programme \"Lili à l'école\" lors de la journée de l'éducation.",
            "0308": "Tu as réfléchi sur l'équité en écoutant \"Fille, garçon : c'est différent ?\" lors de la journée des droits de la femme.",
            "0321": "Tu t'es posé la question \"On est tous pareils ?\" lors de la journée pour l'élimination de la discrimination raciale.",
            "0406": "Tu as écouté \"L'important, c'est de participer ?\" lors de la journée du sport au service du développement et de la paix.",
            "0421": "Tu as développé ta créativité avec une improvisation ou un mime lors de la journée de la créativité et de l’innovation.",
            "0621": "Tu as célébré la journée internationale du yoga en faisant une posture ou une séance en musique. Namasté !",
            "0730": "Tu as pu échanger sur la question \"Ça veut dire quoi, un ami ?\" lors de la journée de l'amitié.",
            "0921": "Tu as médité pour la journée internationale de la paix des Nations Unies.",
            "0922": "Tu as réalisé un atelier de Lili le jour de son anniversaire (Lili a été lancée le 22 septembre 2020).",
            "1031": "Tu as osé écouter le podcast \"J'ai peur !\" le jour de Halloween... Brrrr !",
            "1105": "Tu as réfléchi sur le très sérieux sujet \"Ça va, on rigole !\" lors de la journée de lutte contre le harcèlement.",
            "1203": "Tu as pu réfléchir à la différence avec le podcast \"Ça veut dire quoi, normal ?\" lors de la journée des personnes handicapées.",
            "badge_melomane": "Tu as fait vibrer ta corde musicale en écoutant une bulle sonore et un atelier de yoga en musique.",
            "badge_expressif": "Tu as montré tes talents d'acteur avec le mime \"Alphabet visuel\" et le jeu d’émotion \"La valse des émotions\".",
            "badge_audacieux": "Tu as osé risquer de te tromper avec l'impro \"Super, j’ai raté !\" et le podcast \"Mince, j’ai fait une erreur !\".",
            "badge_aventurier": "Tu es parti à l'aventure avec la relaxation \"L’île intérieure\" et l'exercice de respiration \"La montgolfière\".",
            "badge_joueur": "Tu as été joueur en dessinant \"Victoire !\" et en te posant la question \"L’important, c’est de participer ?\".",
            "badge_courageux": "Tu as été téméraire en jouant à l'improvisation \"Attention à la chute !\" et en dessinant \"Même pas peur !\".",
            "badge_agile": "Tu as su pratiquer un atelier de chacune des sections \"Mes programmes\", \"Je me pose\", \"Je m’exprime\", \"Je grandis\".",
            "badge_grand_lecteur": "Tu as pris plaisir à découvrir au moins 10 conseils de lectures philosophiques dans \"Je grandis\".",
            "badge_pose": "Tu as pris un temps pour toi en construisant un origami, en faisant un dessin, et en remplissant un carnet de philosophie.",
            "badge_repose": "Tu t'es offert du repos en pratiquant un atelier \"Je me pose\" un samedi et un autre un dimanche.",
            "badge_intellectuel": "Tu as fait marcher tes neurones avec le \"Jeu de mémoire\" et le podcast \"Ça veut dire quoi, être intelligent ?\".",
            "badge_curieux": "Tu as éveillé ta curiosité en pratiquant au moins un atelier de chacune des catégories de l'application.",
            "badge_collectionneur": "Tu as peut-être trouvé ta catégorie préférée en réalisant au moins 4 ateliers au sein de celle-ci.",
            "badge_reveur": "Tu as fais un beau voyage grâce à la bulle sonore \"La plage\" et au dessin à dédicacer \"Je me souviens\".",
            "badge_tranquille": "Tu as apaisé ton corps et ton esprit avec la pratique de 3 ateliers \"Je me pose\".",
            "badge_serein": "La sérénité est tienne après la pratique de 10 ateliers \"Je me pose\".",
            "badge_maitre_zen": "La pratique de 20 ateliers \"Je me pose\" t'a permis de rejoindre le club des grands maîtres du zen !",
            "badge_comedien": "Tu as réveillé ton goût pour la comédie avec la pratique de 3 ateliers \"Je m'exprime\".",
            "badge_star": "Les flashs crépitent à ton passage suite à la pratique de 10 ateliers \"Je m'exprime\".",
            "badge_roi_de_la_scene": "La foule t'acclame après avoir joué lors de 20 ateliers \"Je m'exprime\".",
            "badge_enqueteur": "Tu t'es posé de nombreuses questions en pratiquant 3 ateliers \"Je grandis\".",
            "badge_explorateur": "Ton esprit est en effervescence après l'exploration de 10 ateliers \"Je grandis\".",
            "badge_grand_sage": "La sagesse est tienne, acquise au cours de 20 ateliers \"Je grandis\"."
        }
    },
    "websub": {
        "title": "Abonnement à",
        "lah": {
            "subTitle": "Lili pour les super-parents Premium %{duration}",
            "details": "7 jours d'essai gratuits puis %{price}€ par %{duration}",
            "legalMention": "Abonnement %{duration} résiliable à tout moment"
        },
        "las": {
            "subTitle": "Lili pour les super-profs Premium",
            "details": "%{price}€ TTC pour %{duration}"
        },
        "signInButtonTitle": "J'ai déjà un compte",
        "signUpButtonTitle": "Je n'ai pas de compte",
        "signIn": "Je me connecte",
        "signUp": "Je m'inscris",
        "forgotPassword": "Mot de passe oublié"
    }
};